import axios from "axios";
import { API } from "../../Backend";
import {
    ALL_PRODUCT_FAIL,
    ALL_PRODUCT_REQUEST,
    ALL_PRODUCT_SUCCESS,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    CLEAR_ERRORS
} from "../constants/productConstant"

export const getProducts = (currentPage) => async(dispatch) => {
    try {
        dispatch({type: ALL_PRODUCT_REQUEST})
        const {data} = await axios.get(`${API}/products?page=${currentPage}`)
        dispatch({type: ALL_PRODUCT_SUCCESS, payload: data})

    } catch (error) {
        dispatch({
            type: ALL_PRODUCT_FAIL,
            payload: error.response.data.message
        })
    }
}

export const getProductDetails = (handle) => async(dispatch) => {
    try {
        dispatch({type: PRODUCT_DETAILS_REQUEST})
        const {data} = await axios.get(`${API}/product/${handle}`)
        dispatch({type: PRODUCT_DETAILS_SUCCESS, payload: data.product})
        return data
    } catch (error) {
        dispatch({
            type: PRODUCT_DETAILS_FAIL,
            payload: error.response.data.message
        })
        return error.response.data
    }
}

// Used for cleaning errors
export const clearErrors = () => async(dispatch) => {
    dispatch({type: CLEAR_ERRORS})
}